import { BusinessItem } from '@/modules/Dashboard/types'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Typogaphy } from 'vnetwork-ui'

interface BusinessCardProps {
    business: BusinessItem
    index: number
}

const BusinessCard: React.FC<BusinessCardProps> = ({ business, index }) => {
    const { t } = useTranslation('dashboard')

    return (
        <div
            key={business.employee.employee_id}
            className="flex items-center bg-[#F9FBFF] rounded-lg px-4 py-2"
        >
            <div className="flex-1">
                <div className="flex items-center justify-between">
                    <div className="flex-1">
                        <div className="flex items-center">
                            <Typogaphy className="w-4">{index + 1}.</Typogaphy>
                            <Typogaphy className="text-sm">
                                {business.employee.employee_name}
                            </Typogaphy>
                        </div>
                        <Typogaphy className="ps-4 text-sm text-primary capitalize">
                            {business.employee.department_name?.toLowerCase()}
                        </Typogaphy>
                    </div>
                    <Typogaphy className="text-xs font-medium text-[#1D289D]">
                        {t(`business.${business.business_type}`)}
                    </Typogaphy>
                </div>
            </div>
        </div>
    )
}

export default BusinessCard
